<template>
  <div>
    <div class="flex flex-col flex-1 px-4">
      <div class="font-medium text-xs text-gray-600 mb-4">
        <div>
          <span v-if="comment.user">{{ comment.user.firstName }} {{ comment.user.lastName }}</span>
          <template v-if="comment.createdAtDiffForHumans">
            <span class="font-normal">&bull;</span>
            {{ comment.createdAtDiffForHumans }}
          </template>
        </div>

        <div>
          <a role="button" @click="editAction">edit</a>

          &bull;

          <a role="button" @click="deleteAction">delete</a>
        </div>
      </div>
      <p class="text-sm">
        {{ comment.content }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    comment: { type: Object, required: true },
  },

  methods: {
    editAction() {
      this.$emit('edit-comment', this.comment);
    },
    deleteAction() {
      this.$emit('delete-comment', this.comment);
    },
  },
};
</script>
